import { faArrows } from '@fortawesome/pro-light-svg-icons/faArrows';
import { faMinusCircle } from '@fortawesome/pro-light-svg-icons/faMinusCircle';
import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Icon } from '../Icon';
import Input from '../Input/Input';
import { createId } from '../utils/IdGenerator';
import { IListRowProps } from './types';

class ListRow extends Component<PropsWithChildren<IListRowProps>, {}> {
  public inputId = createId('list-row-input');
  public renderControls() {
    if (this.props.hideDelete) {
      return;
    }
    const index = this.props.index + 1;
    return (
      <div className="hlc-listbuilder-controls">
        <Icon icon={faMinusCircle} title={`Delete option #${index}`} onClick={this.props.onDeleteClick} size={'lg'} />
      </div>
    );
  }

  public render() {
    const index = this.props.index;
    const { inputId } = this;
    const wrapperClasses = classNames({
      'has-error': !this.props.isValid,
      'hlc-listbuilder-row': true,
    });
    return this.props.reorderable ? (
      <Draggable draggableId={String(this.props.id)} isDragDisabled={!this.props.reorderable} index={index}>
        {(provided) => (
          <div className={wrapperClasses} ref={provided.innerRef} {...provided.draggableProps}>
            <div className="hlc-listbuilder-row-arrows-wrap" {...provided.dragHandleProps}>
              <Icon icon={faArrows} size={'1x'} />
            </div>
            <div className="hlc-listbuilder-row-input-wrap">
              <label htmlFor={inputId} className="sr-only">
                {`Option #${index}`}
              </label>
              <Input
                value={this.props.value}
                onChange={this.props.onChange}
                valid={!!this.props.isValid}
                touched={!this.props.isValid}
                id={inputId}
                name={this.props.name}
                errorMessage={''}
              />
            </div>
            <div className="delete-btn-wrap">{this.renderControls()}</div>
          </div>
        )}
      </Draggable>
    ) : (
      <div className={wrapperClasses}>
        <div className="hlc-listbuilder-row-input-wrap">
          <label htmlFor={inputId} className="sr-only">
            {`Option #${index}`}
          </label>
          <Input
            value={this.props.value}
            onChange={this.props.onChange}
            valid={!!this.props.isValid}
            touched={!this.props.isValid}
            id={inputId}
            name={this.props.name}
            errorMessage={''}
          />
        </div>
        <div className="delete-btn-wrap">{this.renderControls()}</div>
      </div>
    );
  }
}

export default ListRow;
